<h1 mat-dialog-title>
  Opération: {{ instance?.NumOperProd }} Of: {{ instance?.NumOf }}
</h1>
@if (!userFields) {
  <div><mat-spinner></mat-spinner></div>
}
<form [formGroup]="instanceForm">
  <mat-tab-group dynamicHeight>
    <mat-tab label="Principal">
      <div class="row">
        <div class="tab-content col">
          <table class="cim-full-width" style="margin-top: 8px" cellspacing="0">
            <tr>
              <td>
                <mat-form-field class="cim-full-width">
                  <mat-label>Statut</mat-label>
                  <input
                    #statutOper
                    [value]="
                      instanceForm.get('StatutOper').value | statutOperOf
                    "
                    matInput
                    type="text"
                    i18n-placeholder
                    placeholder="Statut"
                    formControlName="StatutOper"
                    />
                  </mat-form-field>
                </td>
              </tr>
              <tr>
                <td>
                  <mat-form-field class="cim-full-width">
                    <mat-label>Centre</mat-label>
                    <input
                      matInput
                      type="text"
                      i18n-placeholder
                      placeholder="Centre"
                      formControlName="Centre"
                      />
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field class="cim-full-width">
                      <!-- <input matInput type="text" placeholder="Poste" formControlName="Poste"> -->
                      <mat-label>Poste</mat-label>
                      <mat-select
                        (selectionChange)="updateData('Poste', instanceForm.value)"
                        i18n-placeholder
                        placeholder="Poste"
                        formControlName="Poste"
                        [disabled]="!isMovable()"
                        >
                        <mat-option>
                          {{ null }}
                        </mat-option>
                        @if (postes$ | async; as postes) {
                          @for (item of postes.Items; track item) {
                            <mat-option
                              [value]="item.Poste"
                              >
                              {{ item.Poste }}
                            </mat-option>
                          }
                        }
                      </mat-select>
                    </mat-form-field>
                  </td>
                </tr>
              </table>
              <table class="cim-full-width" cellspacing="0">
                <tr>
                  <td>
                    <mat-form-field class="cim-full-width">
                      <mat-label>Qté Lancée</mat-label>
                      <input
                        matInput
                        type="text"
                        placeholder="Qté Lancée"
                        formControlName="QteLancee"
                        />
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field class="cim-full-width">
                        <mat-label>Qté Bonne</mat-label>
                        <input
                          matInput
                          type="text"
                          placeholder="Qté Bonne"
                          formControlName="QteBonne"
                          />
                        </mat-form-field>
                      </td>
                    </tr>
                  </table>
                  <table class="cim-full-width" cellspacing="0">
                    <tr>
                      <td class="cim-50-width">
                        <mat-form-field class="cim-full-width">
                          <mat-label>Tps Prépa</mat-label>
                          <input
                            matInput
                            type="text"
                            placeholder="Tps Prépa"
                            formControlName="TpsPrepa"
                            />
                          </mat-form-field>
                        </td>
                        <td class="cim-16-width">
                          <mat-form-field class="cim-full-width">
                            <mat-label>Heures</mat-label>
                            <input
                              disabled
                              matInput
                              [value]="instanceForm.get('TpsPrepa').value | tpsHours"
                              type="text"
                              placeholder="Heures"
                              />
                            </mat-form-field>
                          </td>
                          <td class="cim-16-width">
                            <mat-form-field class="cim-full-width">
                              <mat-label>Minutes</mat-label>
                              <input
                                disabled
                                matInput
                                [value]="instanceForm.get('TpsPrepa').value | tpsMin"
                                type="text"
                                placeholder="Minutes"
                                />
                              </mat-form-field>
                            </td>
                            <td class="cim-16-width">
                              <mat-form-field class="cim-full-width">
                                <mat-label>Secondes</mat-label>
                                <input
                                  disabled
                                  matInput
                                  [value]="instanceForm.get('TpsPrepa').value | tpsSec"
                                  type="text"
                                  placeholder="Secondes"
                                  />
                                </mat-form-field>
                              </td>
                            </tr>
                          </table>
                          <table class="cim-full-width" cellspacing="0">
                            <tr>
                              <td class="cim-50-width">
                                <mat-form-field class="cim-full-width">
                                  <mat-label>Tps Fabr</mat-label>
                                  <input
                                    matInput
                                    type="text"
                                    placeholder="Tps Fabr"
                                    formControlName="TpsFabr"
                                    />
                                  </mat-form-field>
                                </td>
                                <td class="cim-16-width">
                                  <mat-form-field class="cim-full-width">
                                    <mat-label>Heures</mat-label>
                                    <input
                                      disabled
                                      matInput
                                      [value]="instanceForm.get('TpsFabr').value | tpsHours"
                                      type="text"
                                      placeholder="Heures"
                                      />
                                    </mat-form-field>
                                  </td>
                                  <td class="cim-16-width">
                                    <mat-form-field class="cim-full-width">
                                      <mat-label>Minutes</mat-label>
                                      <input
                                        disabled
                                        #tpsFabrMin
                                        matInput
                                        [value]="instanceForm.get('TpsFabr').value | tpsMin"
                                        type="text"
                                        placeholder="Minutes"
                                        />
                                      </mat-form-field>
                                    </td>
                                    <td class="cim-16-width">
                                      <mat-form-field class="cim-full-width">
                                        <mat-label>Secondes</mat-label>
                                        <input
                                          disabled
                                          matInput
                                          [value]="instanceForm.get('TpsFabr').value | tpsSec"
                                          type="text"
                                          placeholder="Secondes"
                                          />
                                        </mat-form-field>
                                      </td>
                                    </tr>
                                  </table>
                                  <table class="cim-full-width" cellspacing="0">
                                    <tr>
                                      <td class="cim-50-width">
                                        <mat-form-field class="cim-full-width">
                                          <mat-label>Tps Prépa Réel</mat-label>
                                          <input
                                            matInput
                                            type="text"
                                            placeholder="Tps Prépa Réel"
                                            formControlName="TpsPrepaReel"
                                            />
                                          </mat-form-field>
                                        </td>
                                        <td class="cim-16-width">
                                          <mat-form-field class="cim-full-width">
                                            <mat-label>Heures</mat-label>
                                            <input
                                              disabled
                                              matInput
                                              [value]="instanceForm.get('TpsPrepaReel').value | tpsHours"
                                              type="text"
                                              placeholder="Heures"
                                              />
                                            </mat-form-field>
                                          </td>
                                          <td class="cim-16-width">
                                            <mat-form-field class="cim-full-width">
                                              <mat-label>Minutes</mat-label>
                                              <input
                                                disabled
                                                #tpsFabrMin
                                                matInput
                                                [value]="instanceForm.get('TpsPrepaReel').value | tpsMin"
                                                type="text"
                                                placeholder="Minutes"
                                                />
                                              </mat-form-field>
                                            </td>
                                            <td class="cim-16-width">
                                              <mat-form-field class="cim-full-width">
                                                <mat-label>Secondes</mat-label>
                                                <input
                                                  disabled
                                                  matInput
                                                  [value]="instanceForm.get('TpsPrepaReel').value | tpsSec"
                                                  type="text"
                                                  placeholder="Secondes"
                                                  />
                                                </mat-form-field>
                                              </td>
                                            </tr>
                                          </table>
                                          <table class="cim-full-width" cellspacing="0">
                                            <tr>
                                              <td class="cim-50-width">
                                                <mat-form-field class="cim-full-width">
                                                  <mat-label>Tps Fabr Réel</mat-label>
                                                  <input
                                                    matInput
                                                    type="text"
                                                    placeholder="Tps Fabr Réel"
                                                    formControlName="TpsFabrReel"
                                                    />
                                                  </mat-form-field>
                                                </td>
                                                <td class="cim-16-width">
                                                  <mat-form-field class="cim-full-width">
                                                    <mat-label>Heures</mat-label>
                                                    <input
                                                      disabled
                                                      matInput
                                                      [value]="instanceForm.get('TpsFabrReel').value | tpsHours"
                                                      type="text"
                                                      placeholder="Heures"
                                                      />
                                                    </mat-form-field>
                                                  </td>
                                                  <td class="cim-16-width">
                                                    <mat-form-field class="cim-full-width">
                                                      <mat-label>Minutes</mat-label>
                                                      <input
                                                        disabled
                                                        #tpsFabrMin
                                                        matInput
                                                        [value]="instanceForm.get('TpsFabrReel').value | tpsMin"
                                                        type="text"
                                                        placeholder="Minutes"
                                                        />
                                                      </mat-form-field>
                                                    </td>
                                                    <td class="cim-16-width">
                                                      <mat-form-field class="cim-full-width">
                                                        <mat-label>Secondes</mat-label>
                                                        <input
                                                          disabled
                                                          matInput
                                                          [value]="instanceForm.get('TpsFabrReel').value | tpsSec"
                                                          type="text"
                                                          placeholder="Secondes"
                                                          />
                                                        </mat-form-field>
                                                      </td>
                                                    </tr>
                                                  </table>
                                                  <table class="cim-full-width" cellspacing="0">
                                                    <tr>
                                                      <td>
                                                        <mat-form-field class="cim-full-width">
                                                          <mat-label>Main d'oeuvre nécessaire</mat-label>
                                                          <input
                                                            matInput
                                                            type="text"
                                                            placeholder="Main d'oeuvre nécessaire"
                                                            formControlName="QteMo"
                                                            />
                                                          </mat-form-field>
                                                        </td>
                                                        <td>
                                                          <mat-form-field
                                                            class="cim-full-width"
                                                            (change)="updateData('CapacitePoste', instanceForm.value)"
                                                            >
                                                            <mat-label>Nb Machines</mat-label>
                                                            <input
                                                              matInput
                                                              type="text"
                                                              placeholder="Nb Machines"
                                                              formControlName="CapacitePoste"
                                                              [readonly]="!isMovable()"
                                                              />
                                                            </mat-form-field>
                                                          </td>
                                                          <td>
                                                            <mat-form-field class="cim-full-width">
                                                              <mat-label>Temps Prévu / Nb Machine</mat-label>
                                                              <input
                                                                disabled
                                                                matInput
                                                                type="text"
                                                                placeholder="Temps Prévu / Nb Machine"
                    [value]="
                      (
                        (instanceForm.get('TpsFabr').value +
                          instanceForm.get('TpsPrepa').value) /
                        (instanceForm.get('CapacitePoste').value ?? 1)
                      ).toFixed(3)
                    "
                                                                />
                                                              </mat-form-field>
                                                            </td>
                                                          </tr>
                                                        </table>
                                                        <table class="cim-full-width" cellspacing="0">
                                                          <tr>
                                                            <td>
                                                              <mat-form-field class="cim-full-width">
                                                                <mat-label>Date début jalon enregistrée</mat-label>
                                                                <input
                                                                  matInput
                                                                  type="datetime-local"
                                                                  placeholder="Date début jalon enregistrée"
                                                                  formControlName="DateDebutJalon"
                                                                  />
                                                                </mat-form-field>
                                                              </td>
                                                              <td>
                                                                <mat-form-field class="cim-full-width">
                                                                  <mat-label>Date fin jalon enregistrée</mat-label>
                                                                  <input
                                                                    matInput
                                                                    type="datetime-local"
                                                                    placeholder="Date fin jalon enregistrée"
                                                                    formControlName="DateFinJalon"
                                                                    />
                                                                  </mat-form-field>
                                                                </td>
                                                              </tr>
                                                            </table>
                                                            <table class="cim-full-width" cellspacing="0">
                                                              <tr>
                                                                @if (data.param['ExpressRealise'] !== 'Temps') {
                                                                  <td>
                                                                    <fieldset>
                                                                      <legend>{{ "Réalisé en Quantités" }}</legend>
                                                                      <mat-form-field class="cim-full-width">
                                                                        <mat-label>% Avancement</mat-label>
                                                                        <input
                                                                          matInput
                                                                          type="text"
                                                                          placeholder="% Avancement"
                      [value]="
                        instanceForm.get('QteLancee').value
                          ? (
                              (instanceForm.get('QteBonne').value /
                                instanceForm.get('QteLancee').value) *
                              100
                            ).toFixed(2)
                          : null
                      "
                                                                          />
                                                                        </mat-form-field>
                                                                      </fieldset>
                                                                    </td>
                                                                  }
                                                                  @if (data.param['ExpressRealise'] === 'Temps') {
                                                                    <td>
                                                                      <fieldset>
                                                                        <legend>{{ "Réalisé en Temps" }}</legend>
                                                                        <div class="avancement">
                                                                          <mat-form-field class="cim-full-width">
                                                                            <mat-label>Avancement Prépa</mat-label>
                                                                            <input
                                                                              matInput
                                                                              type="text"
                                                                              placeholder="Avancement Prépa"
                        [value]="
                          instanceForm.get('TpsPrepa').value
                            ? (
                                (instanceForm.get('TpsPrepaReel').value /
                                  instanceForm.get('TpsPrepa').value) *
                                100
                              ).toFixed(2)
                            : null
                        "
                                                                              />
                                                                            </mat-form-field>
                                                                            <mat-form-field class="cim-full-width">
                                                                              <mat-label>Avancement Fabr</mat-label>
                                                                              <input
                                                                                matInput
                                                                                type="text"
                                                                                placeholder="Avancement Fabr"
                        [value]="
                          instanceForm.get('TpsFabr').value
                            ? (
                                (instanceForm.get('TpsFabrReel').value /
                                  instanceForm.get('TpsFabr').value) *
                                100
                              ).toFixed(2)
                            : null
                        "
                                                                                />
                                                                              </mat-form-field>
                                                                            </div>
                                                                          </fieldset>
                                                                        </td>
                                                                      }
                                                                    </tr>
                                                                  </table>
                                                                  <table class="cim-full-width" cellspacing="0">
                                                                    <tr>
                                                                      <td>
                                                                        <mat-checkbox #ratio [checked]="true" formControlName="Ratio"
                                                                          >Préserver le ratio</mat-checkbox
                                                                          >
                                                                        </td>
                                                                      </tr>
                                                                    </table>
                                                                    <table class="cim-full-width" cellspacing="0">
                                                                      <tr>
                                                                        <td>
                                                                          <mat-form-field class="cim-full-width">
                                                                            <mat-label>Date début jalon</mat-label>
                                                                            <input
                                                                              matInput
                                                                              [matDatepicker]="picker"
                                                                              #dateDebutJalon
                                                                              placeholder="Date début jalon"
                                                                              [value]="data.task.start_date"
                    (dateChange)="
                      dateHasChanged('start', $event, ratio.checked)
                    "
                                                                              [disabled]="!isMovable()"
                                                                              />
                                                                              <mat-datepicker-toggle
                                                                                matSuffix
                                                                                [for]="picker"
                                                                              ></mat-datepicker-toggle>
                                                                              <mat-datepicker #picker></mat-datepicker>
                                                                            </mat-form-field>
                                                                          </td>
                                                                          <td>
                                                                            <ngx-timepicker-field
                                                                              [format]="24"
                                                                              #timeDebutJalon
                                                                              [disabled]="!isMovable()"
                                                                            ></ngx-timepicker-field>
                                                                          </td>
                                                                          <td>
                                                                            <mat-form-field class="cim-full-width">
                                                                              <mat-label>Date fin jalon</mat-label>
                                                                              <input
                                                                                matInput
                                                                                [matDatepicker]="picker2"
                                                                                placeholder="Date fin jalon"
                                                                                [value]="data.task.end_date"
                                                                                (dateChange)="dateHasChanged('end', $event, ratio.checked)"
                                                                                [disabled]="!isMovable()"
                                                                                />
                                                                                <mat-datepicker-toggle
                                                                                  matSuffix
                                                                                  [for]="picker2"
                                                                                ></mat-datepicker-toggle>
                                                                                <mat-datepicker #picker2></mat-datepicker>
                                                                              </mat-form-field>
                                                                            </td>
                                                                            <td>
                                                                              <ngx-timepicker-field
                                                                                [format]="24"
                                                                                #timeFinJalon
                                                                                [disabled]="!isMovable()"
                                                                              ></ngx-timepicker-field>
                                                                            </td>
                                                                          </tr>
                                                                        </table>
                                                                      </div>
                                                                      @if (data.param.NbChampsUserOpOnMainTab) {
                                                                        <div class="tab-content col">
                                                                          @for (indice of indicesUserfieldsToShowOnMainTab; track indice) {
                                                                            <div
                                                                              class="user-field-container"
                                                                              >
                                                                              <div>
                                                                                <mat-form-field appearance="fill">
                                                                                  <mat-label>{{
                                                                                    data.param["TitreUser" + indice] ?? "Champ User" + indice
                                                                                  }}</mat-label>
                                                                                  <input
                                                                                    readonly
                                                                                    matInput
                  [placeholder]="
                    data.param['TitreUser' + indice] ?? 'Champ User' + indice
                  "
                                                                                    [formControlName]="'UserField' + indice"
                                                                                    />
                                                                                  </mat-form-field>
                                                                                </div>
                                                                              </div>
                                                                            }
                                                                          </div>
                                                                        }
                                                                      </div>
                                                                    </mat-tab>
                                                                    <mat-tab label="Champs User">
                                                                      <div class="tab-content">
                                                                        @for (indice of indicesUserfields; track indice) {
                                                                          <div
                                                                            class="user-field-container"
                                                                            >
                                                                            <div>
                                                                              <mat-form-field appearance="fill">
                                                                                <mat-label>{{
                                                                                  data.param["TitreUser" + indice] ?? "Champ User" + indice
                                                                                }}</mat-label>
                                                                                <input
                                                                                  readonly
                                                                                  matInput
                [placeholder]="
                  data.param['TitreUser' + indice] ?? 'Champ User' + indice
                "
                                                                                  [formControlName]="'UserField' + indice"
                                                                                  />
                                                                                </mat-form-field>
                                                                              </div>
                                                                            </div>
                                                                          }
                                                                        </div>
                                                                      </mat-tab>
                                                                    </mat-tab-group>
                                                                    <div mat-dialog-actions>
                                                                      <button
                                                                        mat-raised-button
                                                                        cdkFocusInitial
                                                                        class="mat-raised-button mat-primary"
                                                                        (click)="close()"
                                                                        >
                                                                        Ok
                                                                      </button>
                                                                      <button
                                                                        mat-raised-button
                                                                        [mat-dialog-close]="false"
                                                                        cdkFocusInitial
                                                                        class="mat-raised-button mat-warn"
                                                                        >
                                                                        Cancel
                                                                      </button>
                                                                    </div>
                                                                  </form>
